import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import { HeaderLink } from ".";
import { useAppSelector } from "../../../redux/hooks";
import { formatMoney } from "../../../utils/StringUtils";
import { useSiteContext } from "../../SiteProvider";
import { SiteBrandingType } from "../../../types/misc";

const NavBalance = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 20,
  fontSize: 12,
  fontWeight: 600,
  color: theme.vars.palette.common.white,
  backgroundColor: theme.vars.palette.primary.main,
  //   border: `2px solid ${theme.vars.palette.primary.main}`,
  borderRadius: 99,
  padding: "1px 13px 0 13px",
  margin: "0px",
}));

const AuthHeader = ({ onClose }: { onClose?: (e: any) => void }) => {
  const { siteBrandingType } = useSiteContext();
  const { rewards } = useAppSelector(({ rewards }) => rewards);
  const currentBalance = rewards.currentBalance;

  return (
    <>
      {siteBrandingType === SiteBrandingType.BrandStore ||
      siteBrandingType === SiteBrandingType.CustomStore ? null : (
        <Link to={`/shop`} className="link" onClick={onClose}>
          <HeaderLink>
            <div className="label">Shop</div>
          </HeaderLink>
        </Link>
      )}

      {currentBalance ? (
        <Link to={"/dashboard/rewards"} className="link" onClick={onClose}>
          <HeaderLink>
            <div className="label">Rewards</div>
            <NavBalance>{formatMoney(currentBalance)}</NavBalance>
          </HeaderLink>
        </Link>
      ) : (
        <Link to={"/dashboard/rewards"} className="link" onClick={onClose}>
          <HeaderLink>
            <div className="label">Rewards</div>
          </HeaderLink>
        </Link>
      )}
    </>
  );
};
export default AuthHeader;
